import {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import MessageType from '../../../../enums/MessageType';
import Button from '../../../../UI/Button/Button';
import {updateDeliveryAddressField} from '../../../actions/address-actions';
import {hideOverlay} from '../../../actions/overlay-actions';
import FieldContainer2 from '../../../form/FieldContainer2';
import Language from '../../../lang/language';
import {getSelectedDeliveryCountry, isSelectedAddressValidForCBEC} from '../../../selectors/selectors';
import V2Components from '../../../v2-components';
import addressDefinitionsByCountry from '../../address/address-definitions-by-country';
import AddressFields from '../../address/AddressFields';
import Message from '../../ui/Message/Message';
import CheckoutOverlay from '../CheckoutOverlay';

import './EditDeliveryAddressOverlay.scss';

// Fields which are not allowed to be editable in the overlay.
// For example, we don't allow them to change their postcode at this point so delivery options aren't re-requested.
// This must match the name as declared in address-definitions-by-country
const uneditableFields = ['postCode'];

export class EditDeliveryAddressOverlay extends Component {
  constructor() {
    super();
    this.handleContinueButtonClick = this.handleContinueButtonClick.bind(this);
    this.exitOverlay = this.exitOverlay.bind(this);
    this.state = {showErrorMessage: false};
  }
  
  handleContinueButtonClick() {
    if (this.fieldContainer.validate().isValid) {
      this.exitOverlay();
    } else {
      this.setState({showErrorMessage: true});
    }
  }
  
  exitOverlay() {
    const addressListComponent = V2Components.get('deliveryAddressList');
    addressListComponent && addressListComponent.validateAfterNextRender && addressListComponent.validateAfterNextRender();
    this.props.hideOverlay();
  }
  
  exitCallback() {
    V2Components.get('deliveryAddressList').validate(); // Update the errors on the main address section, in case the customer navigates back to it.
  }
  
  render() {
    const fieldsToShow = addressDefinitionsByCountry.get(this.props.deliveryCountry)
      .filter(field => !field.filterCondition || field.filterCondition({addressType: 'delivery'}))
      .filter(field => uneditableFields.indexOf(field.name) === -1);
    
    return (
      <CheckoutOverlay
        popup
        title="checkout.delivery.address.section.heading.text"
        exitCallback={this.exitCallback}
      >
        <div className="EditDeliveryAddressOverlay fields">
          {this.state.showErrorMessage && (
            <div className="EditDeliveryAddressOverlay__message">
              <Message type={MessageType.ERROR}>
                {Language.formatLinkText(
                  Language.getText('deliveryOptions.import.tax.chinese.address.error.linked'),
                  {onClick: this.exitOverlay},
                )}
              </Message>
            </div>
          )}
          
          <FieldContainer2 fieldUpdateDispatcher={this.props.updateAddressField}>
            {(fieldContainer) => {
              this.fieldContainer = fieldContainer;
              return (
                <AddressFields
                  definedFields={fieldsToShow}
                  addressType="delivery"
                  fieldContainer={fieldContainer}
                  fieldNamePrefix="deliveryAddress"
                  fieldValues={this.props.addressValues}
                />
              );
            }}
          </FieldContainer2>
          
          <div className="EditDeliveryAddressOverlay__updateButton">
            <Button
              id="EditDeliveryAddressOverlay__updateAddressButton"
              primary
              fullWidth
              onClick={this.handleContinueButtonClick}
            >
              {Language.getText('btn.update.address')}
            </Button>
          </div>
          <div className="EditDeliveryAddressOverlay__cancelButton">
            <Button
              id="EditDeliveryAddressOverlay__cancelButton"
              textOnly
              fullWidth
              onClick={this.exitOverlay}
            >
              {Language.getText('btn.cancel.text')}
            </Button>
          </div>
        </div>
      </CheckoutOverlay>
    );
  }
}

const mapStateToProps = state => ({
  deliveryCountry: getSelectedDeliveryCountry(state),
  addressValues: state.address.deliveryAddressList.addresses[''],
  isAddressValid: isSelectedAddressValidForCBEC(state),
});

function mapDispatchToProps(dispatch) {
  return {
    hideOverlay: bindActionCreators(hideOverlay, dispatch),
    updateAddressField: (fieldName, value) => {
      dispatch(updateDeliveryAddressField({addressId: ''}, fieldName, value));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditDeliveryAddressOverlay);
